export default {
  SET_FEES(state, payload) {
    state.ManagementFee = payload.fees.ManagementFee;
    state.OtherFees = payload.fees.OtherFees;
    state.Service12b1Fee = payload.fees.Service12b1Fee;
    state.UnderlyingFundsFee = payload.fees.UnderlyingFundsFee;
  }
};
